import styled from "styled-components";

export const SubmitReqPreSubBtnsStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > button {
    background-color: gray;
    padding: 8px;
    border-radius: 12px;

    background-color: #ffffff;
  }

  & > .cancel {
    flex-basis: 30%;
    color: #353a50;
    background-color: #eaebed;
  }

  & > .submit {
    flex-basis: 60%;
    box-shadow: 0 3px 10px 0 rgba(255, 191, 29, 0.4);
    background-color: #ffbf1d;
  }
`;
